import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  transform: "translate(0 -3)",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.688 0c-.767 0-1.378.52-1.597 1.18a.75.75 0 0 0 1.424.473c.039-.117.123-.153.172-.153h.65c.029 0 .064.011.098.048a.26.26 0 0 1 .065.176c0 .116-.064.19-.114.213l-1.391.649c-.624.29-.995.928-.995 1.596v.568c0 .414.336.75.75.75h2.5a.75.75 0 0 0 0-1.5h-1.689a.2.2 0 0 1 .068-.055l1.391-.649c.615-.287.98-.914.98-1.572C14 .818 13.3 0 12.337 0zM.236 4.703a.75.75 0 0 1 1.06.034L4.5 8.153l3.203-3.416a.75.75 0 1 1 1.094 1.026L5.528 9.25l3.27 3.487a.75.75 0 0 1-1.095 1.026L4.5 10.347l-3.203 3.416a.75.75 0 0 1-1.094-1.026L3.472 9.25.202 5.763a.75.75 0 0 1 .035-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const EditorSuperscript = { render };
export {
  EditorSuperscript as default,
  render
};
//# sourceMappingURL=EditorSuperscript.svg.js.map
